module.exports = __webpack_public_path__ + "img/import-icon.d03b9e36.svg";